
import { DefaultBackdropProps } from "../../components/default-backdrop";
import { DefaultDialogProps } from "../../components/default-dialog";
import { DefaultMessageProps } from "../../components/default-message";
import { ACTION_TYPES, useBaseLayoutDispatch } from "./base-layout-context";
import axios, { AxiosError } from 'axios';
import { IMessageResponse } from "../../../model/base/response/message-response";

export const useBaseLayoutController = () => {
    const baseLayoutDispatch = useBaseLayoutDispatch();

    const handlerErrorShowMessage = (error: AxiosError) => {

        if (error?.response?.status === 500) {
            showMessage({ open: true, message: "Ocorreu uma falha nao tratada na execução.", type: "error" });
            setLoading(false);
            showBackDrop(false);
        } else if (error.response?.status === 400) {

            if (error.response.data !== null && error.response.data !== undefined) {
                var messageResponse = Object.assign({} as IMessageResponse, error.response.data);
                setLoading(false);
                showMessage({ open: true, message: messageResponse.message, type: "error" });
            } else {
                showMessage({ open: true, message: "Ocorreu uma falha nao tratada na execução.", type: "error" });
            }

        } else if (error.response?.status === 401) {
            window.location.href = `/?action=login`;
        }
        showBackDrop(false);
    }

    const showDialog = async (props: DefaultDialogProps) => {
        await baseLayoutDispatch({
            type: ACTION_TYPES.setDialogProps,
            payload: {
                ...props, open: true, onClose: () => {
                    baseLayoutDispatch({
                        type: ACTION_TYPES.setDialogProps,
                        payload: { ...props, open: false }
                    })
                }
            }
        });
    }

    const setLoading = async (loading: boolean) => {
        await baseLayoutDispatch({
            type: ACTION_TYPES.setLoading,
            payload: loading
        });
    }
    const showBackDrop = async (loading: boolean) => {
        setLoading(loading);
        await baseLayoutDispatch({
            type: ACTION_TYPES.setBackdropPros,
            payload: { open: loading } as DefaultBackdropProps
        });
    }

    const showMessage = async (props: DefaultMessageProps) => {
        await baseLayoutDispatch({
            type: ACTION_TYPES.setMessageProps,
            payload: {
                ...props, open: true, onClose: () => {
                    baseLayoutDispatch({
                        type: ACTION_TYPES.setMessageProps,
                        payload: { ...props, open: false }
                    })
                }
            }
        });
    }


    return {
        showDialog, showMessage, setLoading, showBackDrop, handlerErrorShowMessage
    };
}